<script>
import TimeZoneChooser from '@/tenant/components/TimeZoneChooser.vue';

export default {
  components: {
    TimeZoneChooser,
  },

  props: {
    timeZoneId: { type: String, required: true },
  },

  methods: {
    onTimeZoneIdInput(value, trigger) {
      this.$emit('input', value);
      trigger({ payload: { unix_id: value } });
    },
  },
}
</script>

<template>
  <b-card>

    <h4 class="mb-0 text-center"> Reporting </h4>

    <div class="mt-3"></div>

    <api-trigger
      method="put"
      url="v1/tenant/time-zone"
      @executed="$emit('updated', $event)"
      :show-busy="false">
      <div slot-scope="{busy, trigger}">

        <time-zone-chooser
          :value="timeZoneId"
          @input="onTimeZoneIdInput($event, trigger)"
          :disabled="busy"
          class="mb-0" />

        <div v-if="busy" class="text-success small">
          <i class="fa fa-spinner fa-spin"></i>
          Saving timezone...
        </div>

        <b-alert variant="secondary" show class="mt-3">
          Reports emailed daily at <u>22h00</u> in the selected TimeZone.
        </b-alert>

      </div>
    </api-trigger>

  </b-card>
</template>



// WEBPACK FOOTER //
// src/tenant/components/TenantReportingCard.vue